import React from 'react';
import NavBar from "../../components/Navbar/NavBar";
import FooterOne from "../../components/Footer/Footer";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import { Box, Container, Grid, Typography, useTheme, useMediaQuery } from '@mui/material';
import { mentorshipImages } from '../../utils/BeadsData';

const Mentorship = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box>
            <NavBar />
            <Container sx={{ mt: 12, mx: 'auto', mb: isMobile ? 2 : 8 }}>
                <Typography variant="h4" gutterBottom sx={{ my: 3, textAlign: 'center', fontWeight: 'bold' }}>BEADS MENTORSHIP PROGRAM</Typography>

                <Grid container spacing={5} justifyContent="center" sx={{ mt: 2 }}>
                    <Grid item xs={12} md={6}>
                        <Swiper
                            modules={[Autoplay, EffectFade]}
                            effect="fade"
                            fadeEffect={{ crossFade: true }}
                            autoplay={{ delay: 4000, disableOnInteraction: false }}
                            loop={true}
                            style={{ borderRadius: '2rem' }}
                        >
                            {mentorshipImages.map((image, index) => (
                                <SwiperSlide key={index}>
                                    <Box sx={{ position: 'relative', height: isMobile ? 250 : 400 }}>
                                        <img src={image.src} alt={image.alt}
                                            style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                                        <Typography
                                            variant={isMobile ? "body2" : "subtitle1"}
                                            sx={{
                                                position: 'absolute',
                                                bottom: 0,
                                                width: '100%',
                                                color: 'white',
                                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                padding: '6px',
                                                textAlign: 'center',
                                                fontSize: isMobile ? '0.75rem' : '1rem',
                                            }}
                                        >
                                            {image.description}
                                        </Typography>
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <Typography variant="body1" paragraph>
                            Beads for Education and Development (BEADS) is a non-profit organization committed to empowering children especially girls and women through mentorship programs. Focusing on education and personal development, BEADS endeavors to create sustainable solutions to break the cycle of poverty, particularly in underprivileged communities.
                        </Typography>

                        <Typography variant="body1" paragraph>
                            The organization offers mentorship opportunities to girls and women, enabling them to acquire the skills and knowledge necessary to lead independent and fulfilling lives. By investing in education, BEADS not only emphasizes the importance of learning but also fosters a sense of community, support, and growth.
                        </Typography>

                        <Typography variant="body1" paragraph>
                            The organization's efforts in mentorship build a bridge for women to transition into professional and leadership roles, nurturing potential, and inspiring change. Whether through scholarships, educational programs, or personal mentorship, BEADS works to create lasting impact by transforming the lives of girl children and women, one bead at a time.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>

            <Container sx={{ my: 8, mx: 'auto' }}>
                <Typography variant="h5" gutterBottom align="center" fontWeight="bold" sx={{ mt: 5, mb: 2 }}>Why do we do it?</Typography>

                <Grid container spacing={4} >
                    <Grid item xs={12} md={4}>
                        <Box
                            component='img'
                            src="assets/img/mentor/Rebecca-Ment.jpeg"
                            alt="Rebecca"
                            sx={{ width: '100%', height: 300, borderRadius: '1rem', mx: 'auto', objectFit: 'cover' }}
                        />
                    </Grid>

                    <Grid item xs={12} md={8}>
                        <Typography variant="body1" paragraph>
                            The importance of mentorship and coaching for girls from marginalized communities cannot be overemphasized. It empowers; a key component of BEADS’ mission for the girls from vulnerable communities. According to the UN Educational, Scientific and Cultural Organization (UNESCO), only a third of the world’s researchers is constituted by women (UNESCO, 2017). UNESCO also documents that only a third of all female learners choose STEM subjects in higher education.
                        </Typography>
                        <Typography variant="body1" paragraph>
                            Teenage is an age of opportunity and it is key for education stakeholders to ensure that learners have the skills for self-discovery and understanding (United Nations Children's Fund, 2011). Our mentorship is geared towards equipping our girls with the right skills and preparing them for successful careers. It is aimed at cultivating and nurturing the love for STEM among our girls who would otherwise be sentenced to a life of poverty. They could be married off at an early age to men who are thrice older than them.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>

            <Box sx={{ my: 5, mx: 5 }}>
                <Typography variant="h5" gutterBottom align="center" fontWeight="bold" sx={{ my: 2 }}>How do we do it?</Typography>
                <Typography variant="body1" paragraph sx={{ mx: isMobile ? 1 : 3 }}>
                    We match girls to global STEM experts who have virtual sessions with them. We get most of STEM experts from a great pool of our committed sponsors, STEM focused organizations like USA Army Corps of Engineers and Society of Women Engineers as well as mentorship based organizations like Curious Cardinals. We also get random Volunteer mentors from all over the world.
                </Typography>
            </Box>
            <FooterOne />
        </Box>
    );
};

export default Mentorship;